export default "__VITE_ASSET__93ec452f__"